import axios from "axios"
const url=process.env.REACT_APP_BACKEND_URL
const fileurl=process.env.REACT_APP_LIMIT_URL
const limit_topup_url=process.env.REACT_APP_LIMIT_TOPUP_URL


export const GetAllTopupRequest=async(setIsLoading,setData,handleAlertOpen,data)=>{
    try {
        setIsLoading(true)
        await axios.post(`${url}/lm/topupchecker_list`,data,{
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        })
        .then(response=>{
            setIsLoading(false)
            setData(response.data)
            TopupProcess()
            // setTimeout(()=>{
            //     window.location.reload()
            // },1500)

        })
    } catch (error) {
            setData([])
            setIsLoading(false)
            handleAlertOpen(error.response&&error.response.data.error?error.response.data.error:"Something went wrong","error")
    }
}


export const ApproveTopupRequest=async(data,setData,setIsLoading,handleAlertOpen,handleDialogClose,handleSearch)=>{
    try {
        setIsLoading(true)
        await axios.post(`${url}/lm/topupchecker_approve_or_reject`,data,{
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        })
       .then(response=>{
            if(response.status===200){
                setIsLoading(false)
                 setData({action:"",reason:"",topupids:""})
                 handleDialogClose()
                    handleSearch()

            }

        })
    } catch (error) {
        console.log("error",error);

            setIsLoading(false)
            handleAlertOpen(error.response?error.response.data.error:"Something went wrong","error")
    }
}


export const HandleStatementUpload=async(file,bankname,statementDate,setIsLoading,handleAlertOpen,handleClose)=>{
    try {
        setIsLoading(true)
        const formData = new FormData();
        formData.append('file', file);
        formData.append('date', statementDate);
        await axios.post(`${fileurl}/statement/${bankname}`,formData,{
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            }
        })
        .then((res)=>{
            setIsLoading(false)
            handleAlertOpen(res.data.message,"success")
            handleClose()
        })

    } catch (error) {
        setIsLoading(false)
        handleAlertOpen(error.response?error.response.data.error:"Something went wrong","error")
        handleClose()
    }
}


export const GetStatementStatus=async(page,date,bank,setIsLoading,setData)=>{
    try {
        setIsLoading(true)
        const params = new URLSearchParams();
        params.append('page', page);
        params.append('per_page',5)
        params.append('uploaded_on', date);
        params.append('bank_name', bank);
        await axios.get(`${fileurl}/batch_uploads`,{
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            params
        })
       .then((res)=>{
            setIsLoading(false)
            setData(res.data)
        })

    } catch (error) {
        setIsLoading(false)
        console.log("error",error);
    }
}

export const TopupProcess=async()=>{
    try{
        await axios.post(`${limit_topup_url}process_topupchecker`)
    }
    catch(error){
        console.log("error",error);
        console.clear()
    }




}